import { useEffect } from "react";

import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import {
  ADD_MATERIAL_TRANSPORT,
  MATERIAL_TRANSPORT_SETUP,
} from "../apiEndpoints";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";
import { AddMaterialTransportForm } from "../forms/AddMaterialTransportForm";

export const AddMaterialTransportPage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();

  useEffect(() => {
    getData(MATERIAL_TRANSPORT_SETUP);
  }, []);

  const sendData = async (formValues, reset) => {
    // API calling
    executePost(formValues, ADD_MATERIAL_TRANSPORT, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Add Material Transport" }}>
      {isLoaded && !error ? (
        <AddMaterialTransportForm
          setup={data}
          sendData={sendData}
          successResponse={successResponse}
          loading={loading}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};
